module.exports = __webpack_public_path__ + "static/assets/5a4192521864b66c6fb05e2ec341a9f6.svg";